var map = {
	"./academicInstitution.png": 7014,
	"./bar.png": 3296,
	"./blue-marker.png": 6214,
	"./cinema.png": 2968,
	"./default-icon.png": 2883,
	"./entertainment.png": 4073,
	"./hospital.png": 6141,
	"./hotel.png": 4193,
	"./landscape.png": 9442,
	"./lomapLogo.png": 9038,
	"./lomapLogo2.png": 6003,
	"./monument.png": 4750,
	"./museum.png": 5634,
	"./other.png": 620,
	"./park.png": 9031,
	"./policeStation.png": 7409,
	"./publicInstitution.png": 904,
	"./restaurant.png": 4448,
	"./shop.png": 8768,
	"./sportsClub.png": 4150,
	"./supermarket.png": 5916,
	"./transportCenter.png": 9007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;